export default "__VITE_ASSET__BD2ugVs8__"